import { memo } from "react";
import Tooltip from "../../../../../Elements/Tooltip/Tooltip";
import { useContent } from "../../../../../../contexts/contentContext/contentContext";
import { useTransofrmedDate } from "../../../../../../utils/dateViewTransformer";

import styles from "./styles.module.scss";
import InboxIcon from "../../SenderInfo/components/InboxIcon";
import OutboxIcon from "../../SenderInfo/components/OutboxIcon";

interface JFormInfoI {
  fullName: string;
  senderEmail: string;
  creationDate: string;
  formFields: {
    [key: string]: string;
  }[];
  recipientsList: string[];
  isOutbox: boolean;
  profilePhotoUrl: string;
  recipientInfo: {
    fullName: string;
    senderEmail: string;
    profilePhotoUrl: string;
  };
}

/**
 * Show jform data, such as sender email/name, creation date, and custom form fields
 */
const JFormInfo = memo((props: JFormInfoI) => {
  const {
    fullName,
    senderEmail,
    creationDate,
    formFields = [],
    recipientsList = [],
    isOutbox,
    profilePhotoUrl,
    recipientInfo,
  } = props;

  const { getTextByKey } = useContent();

  const { returnDate, returnTime } = useTransofrmedDate({ date: creationDate });

  return (
    <div className={styles.jformInfoWrapper}>
      {!recipientsList?.length || !isOutbox ? (
        <InboxIcon
          profilePhotoUrl={profilePhotoUrl}
          fullName={fullName}
          senderEmail={senderEmail}
        />
      ) : (
        <OutboxIcon
          isGroup={recipientsList?.length > 1}
          profilePhotoUrl={recipientInfo?.profilePhotoUrl}
          fullName={recipientInfo?.fullName}
          senderEmail={recipientInfo?.senderEmail}
          firstRecipient={recipientsList?.[0]}
        />
      )}
      <div>
        <span>
          <span>{getTextByKey("outbox-sent-by")}: </span>
          <span>
            {/*@ts-ignore*/}
            <Tooltip tooltipText={senderEmail}>
              <span>{fullName?.trim() || senderEmail}</span>
            </Tooltip>
          </span>
        </span>
        <span>
          <span>{getTextByKey("created")} </span>
          <span>
            {returnDate} {returnTime}
          </span>
        </span>
        {formFields.map(({ field, value, type }) => {
          let fieldvalue = value;
          if (type === "recipientDropdown") {
            const recipientListParce = JSON.parse(value);
            fieldvalue = recipientListParce
              .map((recipient: { name: string }) => recipient.name)
              .join(", ");
          }
          return (
            <span key={value} className={styles.fieldWrapper}>
              <span>{field}: </span>
              {/*@ts-ignore*/}
              <Tooltip tooltipText={fieldvalue}>
                <span className={styles.fieldValue}>{fieldvalue}</span>
              </Tooltip>
            </span>
          );
        })}
      </div>
    </div>
  );
});

export default JFormInfo;
